import * as React from "react"
import Svg, { G, Path } from "react-native-svg"

function SvgComponent() {
    return (
        <Svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
        >
            <G
                opacity={0.5}
                stroke="#000"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <Path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <Path d="M22 6l-10 7L2 6" />
            </G>
        </Svg>
    )
}

export default SvgComponent
